const carouselImg = [
	{
		id: 1,
		img: "/kulvratant_landingPage/image-shubecha.png",
		url: "/best-wishes"
	},
	{
		id: 2,
		img: "/kulvratant_landingPage/image-kalavnyas-anand-hot-aahe.png",
		url: '/happy-to-share'
	},
	{
		id: 3,
		img: "/kulvratant_landingPage/image-smuran-din.png",
		url: '/remembrance-day'
	},
	{
		id: 4,
		img: "/kulvratant_landingPage/image-dharmik.png",
		url: '/religious'
	}, {
		id: 5,
		img: "/kulvratant_landingPage/banner-news-and-events.png",
		url: '/news-and-events'
	},
];
export default carouselImg;
